import { MINERVA_API_URL } from '@/config';
import { http } from '@/plugins/http';
import * as types from './mutation-types';

// eslint-disable-next-line import/prefer-default-export
export function fetchJourneyMaps({ commit }, params) {
  return http.get(`${MINERVA_API_URL}/journey_maps`, params)
    .then(res => (commit(types.SET_JOURNEY_MAPS, res.data)))
    .catch(err => Promise.reject(err));
}
